import {Drawer, DrawerProps} from 'antd';
import Style from './index.module.scss';
import Mcp from './Components/Mcps/Mcp';
import DataSet from './Components/DataSet/DataSet';

interface Props extends DrawerProps {
    agentId: string;
}

const Index = ({agentId, ...props}: Props) => {
    return (
        <Drawer title="关联设置" width="1000" className={Style.root} {...props}>
            <div>
                <Mcp agentId={agentId} />
            </div>
            <div>
                <DataSet agentId={agentId} />
            </div>
        </Drawer>
    );
};

export default Index;
